
document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu
  var btn = document.querySelector('.nav-hamburger');
  var menu = document.querySelector('.mobile-menu');
  if (btn && menu) {
    btn.addEventListener('click', function() {
      menu.classList.toggle('open');
    });
  }
  // Close mobile menu on link click
  var mobileLinks = document.querySelectorAll('.mobile-menu a');
  mobileLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      if (menu) menu.classList.remove('open');
    });
  });
});
